import { DateRangePicker, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';

import { useDateRange } from '../DateRangeProvider';

export const DateRangeSelect = () => {
  const { currentDateRange, setCurrentDateRange, shortcuts } = useDateRange();

  return (
    <DateRangePicker
      slots={{ field: SingleInputDateRangeField }}
      name="allowedRange"
      value={currentDateRange}
      onChange={setCurrentDateRange}
      slotProps={{
        shortcuts: {
          items: shortcuts,
        },
        actionBar: { actions: [] },
      }}
      calendars={2}
    />
  );
};
